import axios from "axios";
import { createContext, useContext, useState } from "react";
import { newBaseUrl } from "../Consts"

export const ContactContext = createContext();
export const useContact = () => {
    return useContext(ContactContext);
};

export default function ContactContextProvider({ children }) {
    const [isContact, setIsContact] = useState()
    const [isContactById, setIsContactById] = useState()

    async function getContact(lang) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Content-Language': lang,
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            };
            const res = await axios.get(`${newBaseUrl}/api/contacts`, { headers });
            setIsContact(res?.data)
        } catch (err) {
            console.error(err);
        }
    }

    async function getContactById(id) {
        setIsContactById()
        try {
            const headers = {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            };
            const res = await axios.get(`${newBaseUrl}/api/contact/${id}`, { headers });
            setIsContactById(res?.data)
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <ContactContext.Provider value={{
            getContact, getContactById, isContact, isContactById
        }}>
            {children}
        </ContactContext.Provider>
    );
}
